import { DateTime } from 'luxon'
import type { Period } from '../types/time'

export function convertTo24Hour(hour: string, minute: string, period: Period): string | null {
  if (!hour && !minute && !period) return null
  
  const h = hour || '12'
  const m = minute || '00'
  const p = period || 'AM'
  
  const timeString = `${h.padStart(2, '0')}:${m.padStart(2, '0')} ${p}`
  const dateTime = DateTime.fromFormat(timeString, 'hh:mm a')
  return dateTime.isValid ? dateTime.toFormat('HH:mm') : null
}

export function convertTo12Hour(time24: string | null): { hour: string; minute: string; period: Period } {
  if (!time24) return { hour: '', minute: '', period: 'AM' }
  
  const dateTime = DateTime.fromFormat(time24, 'HH:mm')
  const period = dateTime.toFormat('a') as Period
  
  return {
    hour: dateTime.toFormat('hh'),
    minute: dateTime.toFormat('mm'),
    period
  }
} 